module.exports = __webpack_public_path__ + "static/img/brand_settings.54d2f55b.png";